import { render, staticRenderFns } from "./usMegaMillions.vue?vue&type=template&id=723b79e2&scoped=true"
var script = {}
import style0 from "./usMegaMillions.vue?vue&type=style&index=0&id=723b79e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b79e2",
  null
  
)

export default component.exports